import { useScroll, useSpring, motion } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 220, damping: 30, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden
      style={{ scaleX }}
      className="ops-scroll-progress fixed top-0 left-0 right-0 h-[2px] bg-[#D9FF3C] z-[60] origin-left"
    />
  );
}
